// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react';

const IconX = (props: React.SVGProps<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      width: '1em',
      height: '1em',
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg',
      ...props
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.63615 18.3641C6.02668 18.7546 6.65984 18.7546 7.05037 18.3641L12.0001 13.4143L16.9499 18.3641C17.3404 18.7546 17.9736 18.7546 18.3641 18.3641C18.7546 17.9736 18.7546 17.3404 18.3641 16.9499L13.4143 12.0001L18.3641 7.05037C18.7546 6.65984 18.7546 6.02668 18.3641 5.63615C17.9736 5.24563 17.3404 5.24563 16.9499 5.63616L12.0001 10.5859L7.0504 5.63617C6.65987 5.24565 6.02671 5.24565 5.63618 5.63617C5.24566 6.0267 5.24566 6.65986 5.63618 7.05039L10.5859 12.0001L5.63615 16.9499C5.24563 17.3404 5.24563 17.9736 5.63615 18.3641Z',
      fill: 'current'
    })
  );

export { IconX };
